import React from 'react';
import { useLocation } from 'react-router-dom';
import ExotelVoiceWidget from './ExotelVoiceWidget';

const GlobalVoiceAgent = () => {
  const location = useLocation();
  
  // Do not render the global VoiceAgent on the shared agent page
  if (location.pathname.startsWith('/agent/')) {
    return null;
  }
  
  return <ExotelVoiceWidget />;
};

export default GlobalVoiceAgent;
